import styled from '@emotion/styled'
import facepaint from 'facepaint'

import { css } from '@emotion/react'

const breakpoints = [600]
const mq = facepaint(breakpoints.map((bp) => `@media (min-width: ${bp}px)`))

const Container = styled.section`
  & {
    width: 100%;
  }

  .container {
    width: ${({ theme }) => theme.size.width[90]};
    max-width: ${({ theme }) => theme.size.width[900]};
    height: auto;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column nowrap;
    padding: 140px 0;
  }

  .grid-container {
    display: grid;
    grid-gap: 44px;
  }

  ${css(
    mq({
      '.grid-container': {
        gridTemplateColumns: ['repeat(1, 1fr)', 'repeat(2, 1fr)'],
      },
      '.container': {
        paddingTop: ['100px', '100px', '120px', '140px'],
      },
    }),
  ).styles}
`

export default Container
